import React , {Component} from 'react';
import { connect } from "react-redux";

import backIcon from './../assets/images/icons/back-2.svg';
import bankCardIcon from './../assets/images/icons/bank-card.svg';
import forwardIcon from './../assets/images/icons/forward.svg';
import giftIcon from './../assets/images/icons/gift.svg';
import * as axios from "axios/index";
import * as vars from './Vars';
import {Link} from "react-router-dom";
import NumberFormat from 'react-number-format';
import { Modal } from 'react-bootstrap';
import validator from "validator";

class PaymentV4 extends Component{

    constructor(props){

        super(props)
        this.state = {
            branchSlug : "",
            pay_type : "ONLINE" ,
            use_wallet : 1 ,
            deliveryPrice : 0 ,
            totalPayablePrice : 0 ,
            totalDiscountPrice : 0 ,

            inPageLoading : false ,
            discount_code : "" ,
            errors : {} ,
            fields : {
                discount_code : "" ,
            } ,
            discountCodeError : null ,
            discountCodeModal : false ,

            canSelectOnlinePay : true ,


            removedProduct : [] ,
            removedProductModalShow : false ,


            updatedProductsQtyModalShow : false ,
            updatedProductsQty : [] ,
        }
    }

    componentDidMount(){
        localStorage.setItem("discount_code" , "")
        localStorage.setItem("use_wallet" , 1)
        localStorage.setItem("pay_type" , "ONLINE")
        if (localStorage.getItem("branchOnlinePay") === "false" )
        {
            localStorage.setItem("pay_type" , "IN_PLACE")
            this.setState({
                pay_type : "IN_PLACE" ,
                canSelectOnlinePay : false ,
            })
        }
        this.cartHandler()
    }

    cartHandler(){

        const products = []
        /*this.props.cart.map((object , index) => {
            products.push({
                code : this.props.products[index].code ,
                qty : object
            })
        })*/
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];

            products.push({
                code: product.code,
                qty: qty
            });
        });
        let data = new FormData()
        data.append('api_token' , localStorage.getItem('api_token') )
        data.append('products' , JSON.stringify(products) )
        data.append('address' , localStorage.getItem('selectedAddress') )
        data.append('delivery_type' , localStorage.getItem('NORMAL') )
        data.append('use_wallet' , localStorage.getItem('use_wallet') )
        data.append('discount_code' , localStorage.getItem('discount_code'))
        data.append('delivery_time' , localStorage.getItem('orderDeliveryTimeKey'))
        data.append('delivery_date' , localStorage.getItem('orderDeliveryDateValue'))

        let branchSlug = localStorage.getItem("branchSlug")
        this.setState({
            branchSlug : branchSlug
        })
        axios.post(vars.Url +'api/v4/order/check/' + branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                if (data.cart.removedProducts !== undefined  && data.cart.removedProducts.length > 0)
                {
                    this.setState({
                        removedProduct : data.cart.removedProducts ,
                        removedProductModalShow : true ,
                    })
                    data.cart.removedProducts.map((object,index) => {
                        delete this.props.cart[object.id];
                    })
                }

                if (data.cart.updatedProductsQty !== undefined  && data.cart.updatedProductsQty.length > 0)
                {
                    this.setState({
                        updatedProductsQty : data.cart.updatedProductsQty ,
                        updatedProductsQtyModalShow : true ,
                    })
                    data.cart.updatedProductsQty.map((object,index) => {
                        //console.log(object.qty)
                        this.props.cart[object.id] = object.qty
                        this.props.products[object.id] = {
                            ...this.props.products[object.id],
                            daily_stock_count: object.daily_stock_count
                        }
                    })
                }

                this.setState({
                    totalPayablePrice : data.cart.totalPayablePrice ,
                    totalDiscountPrice : data.cart.totalDiscountPrice ,
                    deliveryPrice : data.cart.deliveryPriceWithDiscount === null ?  data.cart.deliveryPrice : data.cart.deliveryPriceWithDiscount
                })
                localStorage.setItem("totalPayablePrice" , data.cart.totalPayablePrice)
                localStorage.setItem("deliveryPrice" , data.cart.deliveryPriceWithDiscount === null ?  data.cart.deliveryPrice : data.cart.deliveryPriceWithDiscount)
            })
            .catch(error => {
                // console.log(error)
                let data = error.response.data.data
                // console.log(data)

            })

    }
    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }
    discountCodeModalHideHandler()
    {
        this.setState({
            discountCodeModal : false ,
            discountCodeError : null ,
        })
    }
    discountCodeModalSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let formValid = true
        if ( fields.discount_code === null || validator.isEmpty(fields.discount_code))
        {
            formValid = false;
            errors['discount_code'] = 'کد تخفیف را وارد کنید';
        }
        else if(! validator.isLength(fields.discount_code , { min : 2}))
        {
            formValid = false;
            errors['discount_code'] = 'کد تخفیف حداقل باید 2 حرف باشد';
        }
        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }

        this.setState({
            inPageLoading : true ,
            discountCodeError : null ,
        })

        const products = []
        /*this.props.cart.map((object , index) => {
            products.push({
                code : this.props.products[index].code ,
                qty : object
            })
        })*/
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];

            products.push({
                code: product.code,
                qty: qty
            });
        });
        let data = new FormData()
        data.append('api_token' , localStorage.getItem('api_token') )
        data.append('products' , JSON.stringify(products) )
        data.append('address' , localStorage.getItem('selectedAddress') )
        data.append('delivery_type' , localStorage.getItem('NORMAL') )
        data.append('use_wallet' , localStorage.getItem('use_wallet') )
        data.append('discount_code' , this.state.fields.discount_code )


        axios.post(vars.Url +'api/v4/order/check/' + this.state.branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                if (data.cart.removedProducts !== undefined  && data.cart.removedProducts.length > 0)
                {
                    this.setState({
                        removedProduct : data.cart.removedProducts ,
                        removedProductModalShow : true ,
                    })
                    data.cart.removedProducts.map((object,index) => {
                        delete this.props.cart[object.id];
                    })
                }

                if (data.cart.updatedProductsQty !== undefined  && data.cart.updatedProductsQty.length > 0)
                {
                    this.setState({
                        updatedProductsQty : data.cart.updatedProductsQty ,
                        updatedProductsQtyModalShow : true ,
                    })
                    data.cart.updatedProductsQty.map((object,index) => {
                        //console.log(object.qty)
                        this.props.cart[object.id] = object.qty
                        this.props.products[object.id] = {
                            ...this.props.products[object.id],
                            daily_stock_count: object.daily_stock_count
                        }
                    })
                }

                if (data.cart.discountCodeValidation === false)
                {
                    this.setState({
                        discount_code : "" ,
                        inPageLoading : false ,
                        discountCodeError : "کد تخفیف معتبر نمی باشد و یا اعتبار آن به پایان رسیده است!"
                    })
                }
                else
                {
                    this.setState({
                        discount_code : this.state.fields.discount_code ,
                        inPageLoading : false ,
                        discountCodeError : null ,
                        discountCodeModal : false ,
                    })
                    localStorage.setItem('discount_code' ,  this.state.fields.discount_code)
                    this.cartHandler()
                }
            })
            .catch(error => {
                // console.log(error)
                let data = error.response.data.data
                // console.log(data)

            })

    }


    removedProductModalShowHandler(){
        this.setState({
            removedProductModalShow : false ,
            submitErrorMessage : ''
        })
    }

    updatedProductsQtyModalShowHandler(){
        this.setState({
            updatedProductsQtyModalShow : false ,
            submitErrorMessage : ''
        })
    }

    render(){
        const {errors} = this.state
        return(
            <div id="main-custom-1" className="text-decoration-none">

                <Modal
                    show={this.state.removedProductModalShow}
                    onHide={this.removedProductModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        متاسفانه محصولات زیر به دلیل ناموجود شدن، از سبد خرید شما حذف شد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.removedProduct.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.removedProductModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>


                <Modal
                    show={this.state.updatedProductsQtyModalShow}
                    onHide={this.updatedProductsQtyModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        تعداد محصولات زیر در سبد شما تغییر کرد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.updatedProductsQty.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                    حداکثر تعداد قابل خرید:
                                    {object.daily_stock_count}
                                    عدد
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.updatedProductsQtyModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>


                <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                    <div className="content-container">
                        <div className="text-center mb-3">
                            <i className="fas fa-circle-notch fa-spin item-icon"></i>
                        </div>
                        <div className="title">
                            لطفا شکیبا باشید
                        </div>
                    </div>
                </div>
                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container ">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/address">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>

                                            <span className="title">
                                                شیوه پرداخت
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1 has-fixed-footer-1">

                                <div className="row no-gutters justify-content-between align-items-center">
                                    <div className="col-auto">
                                        <div className="title-custom-2">
                                            <img src={bankCardIcon} alt="map" className="item-icon" />
                                            <span className="title">
                                                از چه طریقی پرداخت می کنید؟
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row no-gutters mt-3">
                                    <div className="col-6 pl-2">
                                        <div className={"card-custom-9 "+ (this.state.canSelectOnlinePay === false ? "disabled" : "") + (this.state.pay_type === "ONLINE" ? "active" : "")} onClick={() => {
                                            if(this.state.canSelectOnlinePay === true)
                                            {
                                                console.log(this.state.canSelectOnlinePay)
                                                this.setState({pay_type:"ONLINE"})
                                                localStorage.setItem("pay_type" , "ONLINE")
                                                this.cartHandler()
                                            }
                                        }}>
                                            <div className="title">
                                                <span>
                                                    آنلاین
                                                </span>
                                                {(this.state.canSelectOnlinePay === false ? 
                                                    <div style={{fontSize:"10px"}}>

                                                        در حال حاضر، امکان پرداخت آنلاین نمی باشد
                                                    </div> : "")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 pr-2">
                                        <div className={"card-custom-9 " + (this.state.pay_type === "IN_PLACE" ? "active" : "")} onClick={() => {
                                            this.setState({pay_type:"IN_PLACE"})
                                            localStorage.setItem("pay_type" , "IN_PLACE")
                                            this.cartHandler()
                                        }}>
                                            <div className="title">
                                                هنگام تحویل
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    localStorage.getItem("wallet") > 0 ?
                                        (
                                            <div className="row no-gutters mt-5">
                                                <div className="col">
                                                    <div className={"card-custom-10 " + (this.state.use_wallet === 1 ? "active" : "")} onClick={() => {
                                                        localStorage.setItem("use_wallet" , this.state.use_wallet === 1 ? 0 : 1)
                                                        this.setState({use_wallet: this.state.use_wallet === 1 ? 0 : 1})
                                                        this.cartHandler()
                                                    }}>
                                                        <div className="row no-gutters justify-content-between align-items-center">
                                                            <div className="col-auto">
                                                                <div className="title">
                                                                    استفاده از اعتبار
                                                                </div>
                                                            </div>
                                                            <div className="col-auto text-left">
                                                                <div className="wallet-title">
                                                                    اعتبار فعلی من
                                                                </div>
                                                                <div className="wallet-value">
                                                                    <NumberFormat value={localStorage.getItem("wallet")} displayType={'text'} thousandSeparator={true} className="pl-2" />
                                                                    تومان
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        :
                                        (``)
                                }

                                <div className="row no-gutters mt-5">
                                    <div className="col">

                                        <div className="card-custom-11" onClick={() => this.setState({discountCodeModal : true})}>
                                            <div className="row no-gutters align-items-center justify-content-between">
                                                <div className="col-auto">
                                                    <div className="title">
                                                        <img src={giftIcon} alt="gift" className="item-icon" />
                                                        کد تخفیف دارید؟
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    {
                                                        this.state.discount_code === ""  ?
                                                            (`درج کد`)
                                                            :
                                                            (
                                                                `کد تخفیف : ` + this.state.discount_code
                                                            )
                                                    }

                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                </div>




                <footer id="footer-2" className="text-decoration-none">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="price">
                                                <div className="title">
                                                    جمع کل
                                                </div>
                                                <div className="value">
                                                    <NumberFormat value={this.state.totalPayablePrice} displayType={'text'} thousandSeparator={true}  />
                                                    <span className="currency">
                                                        تومان
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">

                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="delivery-title">
                                                        پیک
                                                    </div>
                                                    <div className="discount-title">
                                                        جمع تخفیف
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="delivery-value">
                                                        {
                                                            this.state.deliveryPrice === 0 ?
                                                                ( `رایگان`)
                                                                :
                                                                (
                                                                    this.state.deliveryPrice + " تومان "
                                                                )
                                                        }
                                                    </div>
                                                    <div className="discount-value">
                                                        <NumberFormat value={this.state.totalDiscountPrice} displayType={'text'} thousandSeparator={true} className="pl-1" />
                                                        تومان
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col">
                                            <Link to="/invoice" className="btn btn-custom-5 btn-block">
                                                ادامه  (فاکتور نهایی)
                                                <img src={forwardIcon} alt="back" className="item-icon" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>


                <Modal
                    show={this.state.discountCodeModal}
                    onHide={this.discountCodeModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            کد تخفیف
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                کد تخفیف را وارد کنید
                                <br />
                            </div>
                        </div>
                        <div>
                            {
                                this.state.discountCodeError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.discountCodeError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                                <input
                                    type="text"
                                    className={["form-control form-control-custom-1" , errors['discount_code'] ? 'is-invalid' : ''].join(' ')}
                                    name="discount_code"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder="کد تخفیف"
                                    value={this.state.fields.discount_code}  />
                                <span className={["invalid-feedback" ,  errors['discount_code'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['discount_code'] }</span>

                                <img src={giftIcon} alt="smart-phone" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.discountCodeModalSubmitHandler.bind(this)}>
                                بررسی و ثبت
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>


            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = state => {
    return {
        cart : state.cart ,
        products : state.products ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(PaymentV4);